import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { useCartWishlist } from "../contexts/CartWishlistContext";
import "./WishlistPage.css";

const formatINR = (amount) =>
  new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(amount);

export default function Wishlist({ embedded }) {
  const { wishlist: items, addToCart, removeFromWishlist, clearWishlist } = useCartWishlist();

  const total = useMemo(
    () => items.reduce((sum, it) => sum + (Number(it.price) || 0), 0),
    [items]
  );

  const removeItem = (id) => removeFromWishlist(id);

  return (
    <div className={embedded ? "wishPage embedded" : "wishPage"}>
      <section className={embedded ? "wishSection embedded" : "wishSection"}>
        <div className={embedded ? "wishWrap embedded" : "wishWrap"}>
          <div className="wishTop">
            <div>
              <h2 className="wishTitle">My Wishlist</h2>
              <p className="wishSub">{items.length} item(s) saved</p>
            </div>

            <div className="wishRight">
              <div className="wishTotal">
                Total: <span>₹{formatINR(total)}</span>
              </div>

              {items.length > 0 && (
                <button className="wishClear" type="button" onClick={clearWishlist}>
                  Clear Wishlist
                </button>
              )}
            </div>
          </div>

          {items.length === 0 ? (
            <div className="wishEmpty">
              <p className="wishEmptyTitle">Your wishlist is empty.</p>
              <Link className="wishGoShop" to="/jewellery">
                Browse Jewellery
              </Link>
            </div>
          ) : (
            <div className="wishGrid">
              {items.map((item) => (
                <div className="wishCard" key={item.id}>
                  <Link to={item.link || "/jewellery"} className="wishMedia">
                    <img className="wishImg" src={item.img} alt={item.name} />
                  </Link>

                  <div className="wishInfo">
                    <Link to={item.link || "/jewellery"} className="wishName">
                      {item.name}
                    </Link>

                    <div className="wishPrice">₹{formatINR(item.price)}</div>

                    <div className="wishActions">
                      <button
                        className="wishAdd"
                        type="button"
                        onClick={() => addToCart(item)}
                      >
                        Add to Cart
                      </button>

                      <button
                        className="wishRemove"
                        type="button"
                        onClick={() => removeItem(item.id)}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}